import { call } from '../callable';

// Admin-only Loops email callables (functions/loops.js). Each resolves the function's data.

/** Send a Loops event: { email, eventName, eventProperties?, contactProperties? }. */
export const loopsSendEvent = call('loopsSendEvent');

/** Send a transactional email: { transactionalId, email, dataVariables }. */
export const loopsSendTransactional = call('loopsSendTransactional');

/** Send a transactional email to many: resolves { sent, failed, total, errors }. */
export const loopsBulkCampaign = call('loopsBulkCampaign');

/** Create or update a Loops contact. */
export const loopsCreateContact = call('loopsCreateContact');

/** Email a beta invite to a waitlist entry and mark it invited: { docId, email, firstName, lastName }. */
export const loopsSendInvite = call('loopsSendInvite');

/** Push every user and waitlist entry to Loops: resolves { synced, failed, total, ... }. */
export const loopsBulkSyncContacts = call('loopsBulkSyncContacts');

/** Email today's system health digest to the admins: resolves { sent }. */
export const sendHealthDigestNow = call('sendDailyHealthDigestNow');
